import {
	IonButton,
	IonButtons,
	IonCol,
	IonContent,
	IonFooter,
	IonGrid,
	IonHeader,
	IonIcon,
	IonImg,
	IonItem,
	IonLoading,
	IonModal,
	IonPage,
	IonRow,
	IonText,
	IonTitle,
	IonToast,
	IonToolbar,
	IonInput 
} from "@ionic/react";
import { get, isEmpty, flatten,last, map as _map, split, isNil, isNull } from "lodash";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { getPartDetails } from "../../api";
import { usePhotoGallery, UserPhoto } from "../../hooks";
import { catchError, EMPTY, switchMap, tap } from "rxjs";
import useAuth from "../../context/auth.context";
import { getImageSrc } from "../../utils";
import { arrowBackOutline, refreshOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { CAMERA_OVERLAY_STYLE, DEFAULT_TOAST_DURATION, ION_TEXT_TABLET_STYLE } from '../../constants';
import { CustomCamera } from '../../components/custom-camera';
//@ts-ignore
import ImageBlobReduce from "image-blob-reduce";
//@ts-ignore
import Pica from "pica";
import { useSettingsContext } from '../../context';

const pica = Pica({ features: ["js", "wasm", "cib"] });
const reduce = new ImageBlobReduce({ pica });

function DetailsPage(	) {
	const { photos, savePhoto, setPhotos, takePhoto } = usePhotoGallery();
	const [loading, setLoading] = useState<boolean>(false);
	const [toastMessage, setToastMessage] = useState<string>("");
	const [maxPhotoCount, setMaxPhotoCount] = useState<number | null>();
	const [isPhotoModalOpen, setIsPhotoModalOpen] = useState<boolean>(false);

	const { acquireToken } = useAuth();

	const location = useLocation();

	const history = useHistory();
	const { theme } = useSettingsContext();
	const { t } = useTranslation();
	const [coords, setCoords] = useState<number[][]>([]);

	function takeInitialPhoto() {
		fetchPartDetails().subscribe((item) => {
			setMaxPhotoCount(get(item, 'metadata.spare_part_max_count', null));
			if (item.photos.length === 0) {
				setPhotos([]);
				takePhotoAndEdit();
			} else {
				setPhotos(item.photos);
			}
		});
	}

	useEffect(() => {
		takeInitialPhoto();
		return () => {
			setLoading(false);
		};
	}, []);

	function onRefresh() {
		setPhotos([]);
		fetchPartDetails().subscribe((item) => {
			setLoading(false);
			setMaxPhotoCount(get(item, 'metadata.spare_part_max_count', null));
			setPhotos(item.photos);
		});
	}

	function fetchPartDetails() {
		const id = split(location.pathname, "/")[2];
		setLoading(true);
		return acquireToken().pipe(
			switchMap((accessToken) => {
				return getPartDetails(id, accessToken);
			}),
			tap(() => setLoading(false)),
			catchError((error) => {
				console.error(error);
				setToastMessage(t("details.fetchPartDetailsError"));
				setLoading(false);
				return EMPTY;
			})
		);
	}

	function takePhotoAndEdit() {
		setIsPhotoModalOpen(true);
	}

	function handleCameraDismiss(imageWebPath: string) {
		if (isNull(imageWebPath) || isEmpty(imageWebPath)) {
			console.log("Camera view cancelled");
			setIsPhotoModalOpen(false);
			return;
		}

		const barcode = split(location.pathname, "/")[2];
		savePhoto(imageWebPath).subscribe((savedPhoto: UserPhoto) => {
			setIsPhotoModalOpen(false);
			const blobId = last(split(savedPhoto.blobPath, "/"));
			history.push(`/edit/${barcode}/${blobId}`);
		});
	}

	function onOpenOptions(photo: any) {
		const barcode = split(location.pathname, "/")[2];
		history.push(
			`/edit/${barcode}/${photo.filepath}?externalPath=${window.btoa(
				photo.blobPath
			)}&isOcr=${get(photo, "metadata.target", "") === "ocr"}`
		);
	}

	function onBack() {
		history.push("/barcode");
	}

	
	
	function onSave(isOcr: boolean) {
		setLoading(true);
		//setDisable(true);
		const partId = split(location.pathname, "/")[2];
		const flattened = flatten(coords);
		
	}

	return (
		<IonPage>
			<IonLoading isOpen={loading} message={t("details.loading")} />
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						{/* <IonBackButton defaultHref='/barcode' /> */}
						<IonButton onClick={onBack} size="large">
							<IonIcon icon={arrowBackOutline} slot="icon-only" />
						</IonButton>
					</IonButtons>
					<IonTitle>
						{t("details.barcodeLabel")}:{" "}
						{split(location.pathname, "/")[2]}
					</IonTitle>
					<IonButtons slot="end">
						<IonButton onClick={onRefresh}>
							<IonIcon icon={refreshOutline} slot="icon-only" />
						</IonButton>
					</IonButtons>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				{!isNil(maxPhotoCount) && photos.length >= maxPhotoCount && (
					<IonItem>
						<IonText
							color={theme === "dark" ? "warning" : "danger"}
							style={ION_TEXT_TABLET_STYLE}
							>
							{t("details.maxPhotoCountReached")}
						</IonText>
					</IonItem>
				)}
				<IonGrid>
					<IonRow>
						{_map(photos, (photo: UserPhoto, index: number) => (
							<IonCol size="6" key={index}>
								<IonImg
									onClick={() => onOpenOptions(photo)}
									src={getImageSrc(photo)}
									style={{
										border:
											get(
												photo,
												"metadata.target",
												""
											) === "ocr"
												? "medium dashed green"
												: "none",
									}}
								/>
							</IonCol>
						))}
					</IonRow>
				</IonGrid>
			</IonContent>
			<IonFooter>
				<IonToolbar>
					<IonButton
						color="primary"
						disabled={!isNil(maxPhotoCount) && photos.length >= maxPhotoCount}
						expand="block"
						// onClick={() => takePhotoAndEdit()}
						onClick={() => setIsPhotoModalOpen(true)}
					>
						{t("details.addNewPhoto")}
					</IonButton>
					
				</IonToolbar>
				
			</IonFooter>
			<IonToast
				duration={DEFAULT_TOAST_DURATION}
				isOpen={!isEmpty(toastMessage)}
				onDidDismiss={() => setToastMessage("")}
				message={toastMessage}
			/>
			<IonModal
				isOpen={isPhotoModalOpen}
				onDidDismiss={() => setIsPhotoModalOpen(false)}
				style={CAMERA_OVERLAY_STYLE}
			>
				<CustomCamera
					onDismiss={handleCameraDismiss}
				/>
			</IonModal>
		</IonPage>
	);
}

export default DetailsPage;
